const galleries = document.querySelectorAll('.product-gallery');

galleries.forEach(gallery => {
  const mainImg = gallery.querySelector('.product-gallery__main img');
  const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt ?? '';

      mainImg.src = src;
      mainImg.alt = alt;

      thumbs.forEach(t => t.classList.remove('product-gallery__thumb--active'));
      thumb.classList.add('product-gallery__thumb--active');
    });
  });
});
